import React from "react";

import { ExperienceType, ForEach } from "common/utils/types";
import { Grid, Card, Typography } from "@material-ui/core";
import { RegisterUserSubformProps } from "./RegisterUserSubformProps";
import { UserInfoField } from "common/components";
import { useTranslation } from "react-i18next";

interface ExperienceDetailsProps extends RegisterUserSubformProps {
  subkey: ExperienceType;
}

export const ExperienceDetails = (props: ExperienceDetailsProps) => {
  //Hooks
  const { t } = useTranslation();

  //Options
  const disabled = props.values.notProvidingExperience;

  const title = () => {
    switch (props.subkey) {
      case ExperienceType.bondsCertificates:
        return t("Bonds");
      case ExperienceType.equity:
        return t("Equity investments");
      case ExperienceType.investments:
        return t("Investment funds");
      case ExperienceType.participations:
        return t("Profit participation rights");
      case ExperienceType.stocks:
        return t("Stocks");
      case ExperienceType.subordinatedLoans:
        return t("Subordinated loans");
      default:
        return undefined;
    }
  };

  return (
    <React.Fragment>
      <Typography variant="subtitle2" className="section-title">
        {title()}
      </Typography>

      <Card className="card--nested">
        <Grid container spacing={5} direction="column">
          <Grid item>
            <UserInfoField id="experience" disabled={disabled} {...props} />
          </Grid>

          {props.values.hasExperience(props.subkey) && (
            <Grid item container spacing={3}>
              <Grid item xs={12} lg={6} md={6} sm={6}>
                <UserInfoField id="transactionsPerYear" {...props} />
              </Grid>

              <Grid item xs={12} lg={6} md={6} sm={6}>
                <UserInfoField id="volumePerYear" {...props} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Card>
    </React.Fragment>
  );
};

export const RegisterUserExperienceSubform = (
  props: RegisterUserSubformProps
) => (
  <Grid container direction="column" spacing={5}>
    <Grid item className="checkbox-center-container" xs={12}>
      <UserInfoField id="notProvidingExperience" {...props} />
    </Grid>

    {ForEach("ExperienceType", (x) => x).map((_, index) => (
      <Grid item key={index}>
        <ExperienceDetails subkey={index} {...props} />
      </Grid>
    ))}
  </Grid>
);
